module.exports = __webpack_public_path__ + "img/scopeofwork.62c45ec6.png";